import { useState } from "react";

// Mantém o texto digitado nos filtros de seleção múltipla (Autocomplete do MUI)
// depois de marcar um item.
//
// Por padrão o MUI limpa a busca a cada seleção: em `selectNewValue` ele chama
// `resetInputValue`, que com `multiple` força o input pra "" e avisa via
// onInputChange com reason "reset" (ver @mui/base/useAutocomplete). Resultado:
// era preciso pesquisar de novo pra cada item que se queria marcar.
//
// Aqui o inputValue passa a ser controlado e só muda quando o motivo é
// digitação ("input") ou o X de limpar ("clear"); "reset" (seleção e blur) é
// ignorado. O texto é zerado quando a lista fecha, pra não sobrar busca antiga
// escondendo o resumo da seleção (placeholder) na próxima abertura.
//
// Uso: const busca = useBuscaSelecaoMultipla();  <Autocomplete multiple {...busca} ... />
// Precisa de `disableCloseOnSelect` no Autocomplete (senão a lista fecha na
// primeira seleção e o texto é zerado pelo onClose).
const useBuscaSelecaoMultipla = () => {
	const [inputValue, setInputValue] = useState("");

	return {
		inputValue,
		onInputChange: (event, valor, motivo) => {
			if (motivo === "input") {
				setInputValue(valor);
			} else if (motivo === "clear") {
				setInputValue("");
			}
		},
		onClose: () => setInputValue(""),
	};
};

export default useBuscaSelecaoMultipla;
